import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  enabled: false,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')

    return systemSettingApi.getBakaiLogSetting()
      .then(({ data }) => commit('BAKAI_LOG_SETTING_FETCHED', data))
      .catch(err => commit('BAKAI_LOG_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateBakaiLogSetting({ enabled: state.enabled })
      .then(() => commit('BAKAI_LOG_SETTING_UPDATED'))
      .catch(error => {
        commit('BAKAI_LOG_SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  BAKAI_LOG_SETTING_FETCHED(state, data) {
    state.enabled = data.enabled
  },
  BAKAI_LOG_SETTING_FETCH_FAILED() {
    store.dispatch('message/error', 'Не удалось прочитать настройку')
  },
  BAKAI_LOG_SETTING_UPDATED() {
    store.dispatch('message/success', 'Настройка сохранена')
  },
  BAKAI_LOG_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'Не удалось сохранить настройку')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
